'use client';

import React from 'react';
import { HelpCircle } from 'lucide-react';
import { OPEN_TOUR_EVENT } from './OnboardingTour';

/**
 * Reopens the workflow tour / tips from anywhere in the app. Dispatches the
 * window event that the always-mounted OnboardingTour listens for.
 */
export default function TourTipsButton({ className = '' }: { className?: string }) {
  return (
    <button
      type="button"
      onClick={() => window.dispatchEvent(new Event(OPEN_TOUR_EVENT))}
      className={`inline-flex items-center gap-1.5 rounded-lg border border-border bg-card px-3 py-1.5 text-xs font-600 text-primary hover:border-primary hover:bg-primary/5 transition-colors ${className}`}
    >
      <HelpCircle size={14} />
      How Seamigo works
    </button>
  );
}
